import PropTypes from 'prop-types';

export default ({
    name: PropTypes.string.isRequired,
    hash: PropTypes.string.isRequired,
    description: PropTypes.string,
    min_tickets_count: PropTypes.number,
    max_tickets_count: PropTypes.number,
});
